import { Pipe, PipeTransform } from '@angular/core';
import { sortBy } from 'lodash';

@Pipe({
    name: 'arraySorting'
})
export class ArraySortingPipe implements PipeTransform {

    transform(value: any[], key: any, useNumericSort: boolean = true): any {
        if (!Array.isArray(value)) {
            return value;
        }

        if (useNumericSort) {
            return sortBy(value, (item) => {
                const number = parseInt(item[key], 10);
                return isNaN(number) ? item[key] : number;
            });
        } else {
            return sortBy(value, key);
        }
    }
}
